import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { ResetPasswordConfirmForm } from "./-components/ResetPasswordConfirmForm";
import { createSEOHead, SEO_DATA } from "@/lib/seo";

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/(public)/(auth)/reinitialiser-mot-de-passe")({
  head: () => createSEOHead({
    ...SEO_DATA.LOGIN,
    title: "Réinitialiser votre mot de passe - HomeToQ",
    description: "Réinitialisez votre mot de passe HomeToQ en toute sécurité"
  }),
  component: RouteComponent,
  validateSearch: resetPasswordSearchSchema,
  beforeLoad: ({ search }) => {
    // Si pas de token, rediriger vers l'accueil
    if (!search.token) {
      throw redirect({
        to: "/",
      });
    }
  },
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return (
    <section className="container mx-auto margin-top w-full px-4">
      <header className="text-center mb-8">
        <h1 className="font-h1 mb-4">Réinitialiser votre mot de passe</h1>
        <p className="font-h4 text-muted-foreground">
          Choisissez un nouveau mot de passe sécurisé pour votre compte HomeToQ
        </p>
      </header>
      
      <ResetPasswordConfirmForm token={token!} />
    </section>
  );
}
